import { Typography } from 'core/common/ui/ui-kit';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { InfoListType } from 'core/flow/entities';
import { IconStyled, InfoContentStyled, InfoItemStyled, InfoListStyled } from './styled';

type InfoListProps = {
  list: Array<InfoListType>;
  className?: string;
};

export const InfoList = ({ list, className }: InfoListProps) => {
  return (
    <InfoListStyled className={className}>
      {list?.map(({ title, value, image }) => (
        <InfoItemStyled key={title}>
          <IconStyled width={24} height={24} src={image.src} alt={image.alt} />
          <InfoContentStyled>
            <Typography
              variant="bodySmallRegular"
              color="textSecondary"
              dangerouslySetInnerHTML={prepareHtml(title)}
            />
            <Typography variant="bodyMediumSemiBold" dangerouslySetInnerHTML={prepareHtml(value)} />
          </InfoContentStyled>
        </InfoItemStyled>
      ))}
    </InfoListStyled>
  );
};
